import {TimeSpan} from "@sparkware/app-utils";
import {namedSetTimeout} from "../common/utils/time-functions";

export function delay(interval: TimeSpan): Promise<void> {
    return new Promise<void>((resolve) => {
        namedSetTimeout('DELAY_TIMER', () => resolve(), interval);
    });
}